import { render, staticRenderFns } from "./EstimateDialog.vue?vue&type=template&id=5f82aad5&scoped=true"
import script from "./EstimateDialog.vue?vue&type=script&lang=js"
export * from "./EstimateDialog.vue?vue&type=script&lang=js"
import style0 from "./EstimateDialog.vue?vue&type=style&index=0&id=5f82aad5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f82aad5",
  null
  
)

export default component.exports